import FamilyTaggingPresenter from "@adapters/presenters/Reports/FamilyTagging";
export default (useCases, actions) => {
    return {
        FamilyTagging: new FamilyTaggingPresenter(actions, useCases),
    };
};
